<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.prenatalConsultations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <b-button class="mb-2" variant="primary" @click="toObstetricParameters">
                        {{ $tc('message.obstetricParameters', 2) }}
                    </b-button>

<!--                    <b-button class="mb-2" variant="primary" @click="toPhysicalExams">-->
<!--                        {{ $tc('message.physicalExams', 2) }}-->
<!--                    </b-button>-->

<!--                    <b-button class="mb-2" variant="primary" @click="toComplementaryExams">-->
<!--                        {{ $tc('message.complementaryExams', 2) }}-->
<!--                    </b-button>-->
                </div>

                <div class="card">
<!--                    <div class="card-body p-1em">-->
<!--                        <h3 class="card-title text-center mb-0">-->
<!--                            {{fullName }} ( {{fileNumber}} )-->
<!--                        </h3>-->
<!--                    </div>-->
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.typeOfConsultation') }}:

                                        <span class="font-weight-bold">
                                {{ mConsultation.type_de_consultation }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.complaints',2) }}:

                                        <span class="font-weight-bold">
                                {{ mConsultation.plaintes}}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.recommendations',2) }}:

                                        <span class="font-weight-bold">
                                {{ mConsultation.recommandations }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.physicalExams',2) }}:

                                        <div class="font-weight-bold">
                                            {{ mConsultation.examen_clinique }}
                                        </div>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.complementaryExams',2) }}:

                                        <div class="font-weight-bold">
                                            {{ mConsultation.examen_complementaire }}
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.createdAt') }}:

                                        <span class="font-weight-bold">
                                {{ formattedDate(mConsultation.created_at) }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.passedAt') }}:

                                        <span class="font-weight-bold">
                                {{ formattedDate(mConsultation.passed_at) }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.archievedAt') }}:

                                        <span class="font-weight-bold">
                                {{ formattedDate(mConsultation.archieved_at) }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>

                    <div class="card-footer text-right">
                        <b-container>
                            <b-row class="justify-content-sm-center">
                                <span v-if="errorshasField('nonTransmis')" style="color:red">
                                    {{getErrorsField('nonTransmis')}}
                                    </span>
                            </b-row>
                            <b-row class="justify-content-sm-center">
                                <b-button variant="primary" @click="updateConsultation" v-if="mConsultation.isAuthor || hasAdminRole">
                                    {{ $t('message.edit') }}
                                </b-button>
                                <b-button variant="success" @click="archieveConsultation" v-if="!isTransmitted(mConsultation.passed_at) && isArchived(mConsultation.archieved_at) && (hasMedecinControleRole || hasAdminRole || hasAssistante)" >
                                    {{ $t('message.archieve') }}
                                </b-button>

                                <b-button variant="info" @click="transmitConsultation" v-if="isTransmitted(mConsultation.passed_at) && (hasPraticienRole || hasAdminRole)">
                                    {{ $t('message.transmit') }}
                                </b-button>
                                <b-button v-b-modal.delete-modal variant="danger" v-if="mConsultation.isAuthor || hasAdminRole">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </b-row>
                        </b-container>
                    </div>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.prenatalConsultations', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mConsultation.type_de_consultation }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteConsultation">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: "Prenatal",

        computed: {
            ...mapGetters(["prenatalConsultation",
                "errors",
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole'
            ]),

            mConsultation: function() {
                return this.prenatalConsultation;
            },
            fullName:function(){
                if (typeof (this.mConsultation.user) == 'object'){
                    let user = this.mConsultation.consultation_obstetrique.dossier.patient.user;
                    return user.prenom? user.prenom+ ' ' : '' + user.nom ? user.nom :'';
                }else{
                    return '';
                }
            },
            fileNumber:function() {
                if (typeof (this.mConsultation.dossier) == 'object') {
                    let dossier = this.mConsultation.consultation_obstetrique.dossier;
                    return dossier.numero_dossier;
                } else {
                    return '';
                }
            }
        },

        data() {
            return {
                consultation_id: this.$route.params.consultation
            }
        },

        methods: {
            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getPrenatalConsultation", { args });
            },

            formattedDate(date) {
                return date ? moment(date).format('DD-MM-YYYY') : 'not yet';
            },

            toObstetricParameters() {
                this.$router.push({ name: 'parameters-obstetric', params: { consultation: this.consultation_id } })
            },

            // toPhysicalExams() {
            //     this.$router.push({ name: 'prenatal-consultation-physicals-examinations', params: { consultation: this.consultation_id } })
            // },
            //
            // toComplementaryExams() {
            //     this.$router.push({ name: 'prenatal-consultation-complementaries-examinations', params: { consultation: this.consultation_id } })
            // },

            updateConsultation() {
                this.$router.push({ name: 'edit-consultation-prenatal', params: { consultation: this.consultation_id } });
            },

            archieveConsultation(){

                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.prenatalConsultationArchieved');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('archievePrenatalConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            transmitConsultation(){
                this.clearErrorField('nonTransmis');
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.prenatalConsultationTransmitted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('transmitPrenatalConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            deleteConsultation() {
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.prenatalConsultationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePrenatalConsultation', { args, index: self.consultation_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },

            isArchived:function(date){
                let momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            isTransmitted:function(date){
                var momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        mounted() {
            this.getConsultation();
        }
    }
</script>

<style scoped>

</style>